import { baseBackend } from "../../../api/base/baseUrl";

const URL_FOOTER = "/api/v1/module/footer";

export const createFooter = async (footer) => {
  return await baseBackend.post(URL_FOOTER, JSON.stringify({ footer }), {
    headers: { "Content-Type": "application/json" },
  });
};
